import React, {Component} from "react";
import './GererUtilisateurs.css'

class GererUtilisateurs extends Component {
    state= {
        id: "",
        utilisateurs: [
            {"id": 1, "username": "admin", "fonction": "رئيس القسم"},
            {"id": 2, "username": "user1", "fonction": "نائب رئيس القسم"},
            {"id": 3, "username": "user2", "fonction": "عون حجز"},
            {"id": 4, "username": "user2", "fonction": "عون حجز"},
        ],
        username: "",
        password: "",
        fonction: "",
        status: 0
    }

    hideModal = () => {
        document.getElementById('id01').style.display='none'
    }

    showModal = () => {
        let modal = document.getElementById('id01');
        modal.style.display = "block";
    }

    clickRow =(e)=> {
        let id = e.currentTarget.id
        this.setState({id: id})
        this.showModal()
    }

    supprimer = () => {


                this.hideModal()

                let tt = document.getElementsByClassName('alert-success')[0]
                tt.innerHTML  = "تم حذف المستخدم"
                tt.style.display  = "block"
                setTimeout(function(){
                    tt.style.display = "none";
                }, 3000);

    }

    usernameChange = (e) => {
        this.setState({ username: e.target.value, password: e.target.value })
    }

    fonctionChange = (e) => {
        this.setState({ fonction: e.target.value })
    }

    enregistrer = (e) => {
        let userExist = false

        if(this.state.username.length < 3) {
            let tt = document.getElementsByClassName('alert')[0]
            tt.innerHTML  = "يجب أن يحتوي إسم المستخدم على 3 أحرف أو أكثر"
            tt.style.display  = "block"
            setTimeout(function(){
                tt.style.display = "none";
            }, 3000);
        } else {

                if(this.state.fonction.length === 0) {
                    let tt = document.getElementsByClassName('alert')[0]
                    tt.innerHTML  = "يرجى اختيار نوع الحساب"
                    tt.style.display  = "block"
                    setTimeout(function(){
                        tt.style.display = "none";
                    }, 3000);
                } else {

                        for(let i=0; i<this.state.utilisateurs.length; i++) {
                            if(this.state.utilisateurs[i].toString() === this.state.username.toString()) {
                                userExist = true
                                let tt = document.getElementsByClassName('alert')[0]
                                tt.innerHTML  = "يوجد مستخدم يحمل هذا الإسم"
                                tt.style.display  = "block"
                                setTimeout(function(){
                                    tt.style.display = "none";
                                }, 3000);
                                break
                            }
                        }
                        if(!userExist) {
                            let tt = document.getElementsByClassName('alert-success')[0]
                            tt.innerHTML  = "تم إنشاء الحساب بنجاح"
                            tt.style.display  = "block"
                            setTimeout(function(){
                                tt.style.display = "none";
                            }, 3000);
                        }
                }
        }
    }

    render() {
        return(
                <div className="gerer-utilisateurs">
                    <h2>إضافة مستخدم جديد</h2>
                    <div id="username">
                        <label>إسم المستخدم</label>
                        <input name="username" type="text" onChange={this.usernameChange} placeholder=""/>
                    </div>
                    <div id="fonction">
                        <label>الوظيفة</label>
                        <select name="fonction" className="field-divided" onChange={this.fonctionChange}>
                            <option value="">إختر نوع الحساب</option>
                            <option value="نائب رئيس القسم">نائب رئيس القسم</option>
                            <option value="عون إدارة">عون إدارة</option>
                            <option value="عون حجز">عون حجز</option>
                        </select>
                    </div>
                    <div>
                        <input type='submit' value='حفظ' onClick={this.enregistrer} />
                    </div>
                    <div id="remarque">
                        <label><span style={{color: "red", fontWeight: "bold"}}>ملاحظة : </span> كلمة المرور هي نفسها إسم المستخدم</label>
                    </div>
                    <div className="liste-utilisateurs">
                        <table>
                            <thead>
                            <tr>
                                <th>إسم المستخدم</th>
                                <th>الوظيفة</th>
                                <th>العملية</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.utilisateurs.map(utilisateur =>
                                <tr key={utilisateur.id}>
                                    <td>{utilisateur.username}</td>
                                    <td>{utilisateur.fonction}</td>
                                    <td><i id={utilisateur.id} onClick={this.clickRow} className="delete fa fa-trash fa-1x"></i></td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                    </div>
                    <div className="alert-section">
                        <div className="alert" style={{display: "none", position: "absolute", alignItems: "center", bottom: 70, minWidth: "300px"}}>

                        </div>
                        <div className="alert-success" style={{display: "none", position: "absolute", bottom: 70, minWidth: "300px"}}>

                        </div>
                    </div>
                    <div id="id01" className="modal1">
                        <div className="container modal-content">

                            <h2>هل تريد حذف المستخدم ؟</h2>

                            <div className="clearfix">
                                <button type="button" onClick={this.hideModal}
                                        className="cancelbtn">لا
                                </button>
                                <button type="button" onClick={this.supprimer}
                                        className="confirmbtn">نعم
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

        )
    }
}

export default GererUtilisateurs